import { Fragment } from 'react';
import dynamic from 'next/dynamic';

import { Container } from '@/atoms';
import { CardService, CardsTabs, Grid } from '@/molecules';

import { sectionBgProps } from '@/utils';
import { ComponentRevisadasBeneficios } from './ComponentRevisadasBeneficios';

/**
 * ComponentRevisadasServiciosTabs
 */
export const ComponentRevisadasServiciosTabs = ({
  ServiciosTab,
  FondoSeccion,
}: any) => {
  const tabs = ServiciosTab.map((child: any) => ({
    titulo: child.TituloTab,
    hash: child.HashTab,
    icono: dynamic(
      () =>
        import(
          `/components/icons/duotone/${child.IconoTab.replaceAll('_', '-')}.svg`
        ),
    ),
  }));

  return (
    <Container wrapper {...sectionBgProps(FondoSeccion)}>
      <CardsTabs tabs={tabs}>
        {ServiciosTab.map((contenidoTab: any, key: number) => (
          <Fragment key={key}>
            <div className="mb-12 flex flex-col gap-6 lg:mb-28 lg:gap-10">
              <h3 className="text-headline-h3">
                {contenidoTab.TituloServicios}
              </h3>

              <Grid className="gap-5" xs={1} md={2}>
                {contenidoTab.servicios.map(
                  (serviciosCards: any, indice: any) => (
                    <Grid.Item key={indice}>
                      <CardService
                        logo={
                          serviciosCards.Logo
                            ? {
                                alt: serviciosCards.Logo?.alternativeText,
                                src: serviciosCards.Logo?.url,
                                width: serviciosCards.Logo?.width,
                                height: serviciosCards.Logo?.height,
                              }
                            : undefined
                        }
                        title={serviciosCards?.Titulo}
                        description={serviciosCards?.Descripcion}
                        tag={serviciosCards?.Tag}
                        theme="light"
                      />
                    </Grid.Item>
                  ),
                )}
              </Grid>
            </div>

            <ComponentRevisadasBeneficios
              Descripcion={contenidoTab?.DescripcionBeneficios}
              beneficios={contenidoTab.beneficios}
              Titulo={contenidoTab?.TituloBeneficios}
            />
          </Fragment>
        ))}
      </CardsTabs>
    </Container>
  );
};

ComponentRevisadasServiciosTabs.displayName = 'ComponentRevisadasServiciosTabs';
